// Phase 486 D-486-10 — provenance updated from the legacy v77.0 IRI-manifest
// substrate to the real Phase 485/486 pipeline.
//
// The v77 demo content is now Phase 485 LLM-synthesized schema-v4 page trees
// (`public/captures/*.page.json`, genuine `claude-sonnet-4-6` output, run
// 2026-05-21 per 486-02-SUMMARY) rendered by the Phase 486 SchemaV4PageRenderer
// (the @cogo/react-renderer ElementRenderer tree-walker). No legacy substrate
// nor a pinned commit SHA is involved any more.
//
// PROVENANCE_LABEL is a single stable literal — a descriptive label, NOT a magic
// hash (CLAUDE.md Bug-Fix rule against fake/magic values applies in spirit).
// Two surfaces (this TS constant + index.html <meta name="cogo-provenance"> tag)
// MUST stay in sync; the Playwright smoke spec greps PROVENANCE_LABEL verbatim
// (tests/smoke.spec.ts) — adjust the smoke spec's PROVENANCE_TEXT together with
// any change here.
//
// Consumers: src/components/ProvenanceFooter.tsx, src/components/DemoCard.tsx.
export const PROVENANCE_LABEL =
  "Generated by Phase 485 LLM synthesis · rendered by Phase 486 ElementRenderer";
